import { render } from "./ExpiringPointDetails.vue?vue&type=template&id=6d2a9196&ts=true"
import script from "./ExpiringPointDetails.vue?vue&type=script&lang=ts"
export * from "./ExpiringPointDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__